
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(776|83|929)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
